import type { AgentAtomDefinition } from "./define";
import { agentInfoAtomDef } from "./info";

export const createAgentClientAtoms = (params: Parameters<AgentAtomDefinition>[0]) => ({
  info: agentInfoAtomDef(params),
});

export type AgentClientAtoms = ReturnType<typeof createAgentClientAtoms>;
